import './App.css';
import Login from './pages/Login/Login';
import { useRoutes } from "react-router-dom"
import router from './router';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/Header/Header';


function App() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // برای اسکرول نرم
    });
  };
  let routes = useRoutes(router)

  return (
    <>
      {
        localStorage.getItem("pelakToken") ? (
          <div className='flex'>
            <div className='w-[18%]'>
              <Sidebar />
            </div >
            <div className='w-[82%] '>
              <Header />
              <div className='px-12'>
                {routes}
              </div>
            </div>
          </div >
        ) : (
          <Login />
        )
      }

      <div onClick={() => scrollToTop()} className='fixed bottom-0 left-0 bg-white border rounded-full p-1 z-50 cursor-pointer hover:animate-bounce  '>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      </div>
    </>
  );
}

export default App;
